export default __webpack_public_path__ + "static/media/tony.5b2c8307.png";